import { render, staticRenderFns } from "./EventCategory.vue?vue&type=template&id=0f6ea496&scoped=true"
import script from "./EventCategory.vue?vue&type=script&lang=js"
export * from "./EventCategory.vue?vue&type=script&lang=js"
import style0 from "./EventCategory.vue?vue&type=style&index=0&id=0f6ea496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ea496",
  null
  
)

export default component.exports